import axios from 'axios'

const getAPI = axios.create({
    // baseURL: 'http://127.0.0.1:8000',
    baseURL: process.env.VUE_APP_API_URL,
    // timeout: 7000,
})

export { getAPI }